import { render } from "./VabeneAddIngredientPage.vue?vue&type=template&id=196d9c54&ts=true"
import script from "./VabeneAddIngredientPage.vue?vue&type=script&lang=ts"
export * from "./VabeneAddIngredientPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__